

import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    function isMetricsRequest(request: HttpRequest<any>): boolean {
      return request && request.url.includes('dbapi/metrics');
    }

    if (this.auth.shouldRenewToken() && !isMetricsRequest(request)) {
      this.auth.renewToken()
        .pipe(take(1))
        .subscribe(
          () => {
            // not implemented. nothing to do here to keep the process transparent
          }
        );
    }

    return next.handle(request);
  }
}
